"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskType = void 0;
var _react = require("react");
var _hooks = require("../../../../../hooks");
var _Select = require("../../../../../UI/Select");
var _useItem = require("../../../hooks/useItem");
var _TaskManager = require("../../../TaskManager.provider");
var _SectionLabel = require("../SectionLabel");
var _SectionDescription = require("../SectionDescription");
var _TaskType = _interopRequireDefault(require("./TaskType.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TaskType = props => {
  const {
    itemID,
    taskID,
    itemLanguage,
    environmentID,
    audienceID,
    kotarParams,
    isChangeAudienceAfterSubmitEnabled,
    isLearningActivity,
    isSelfLearningEnabled,
    isTaskTypeChangeEnabled,
    isScheduleOnlyExam,
    minDate,
    maxDate
  } = props;
  const {
    task,
    setTask,
    originalTask,
    unitData,
    setIsChanged,
    language,
    getLabel,
    isChangedBackToExam,
    setIsChangedBackToExam
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    getTaskTiming
  } = (0, _useItem.useItem)(itemID, itemLanguage, environmentID, audienceID, taskID, kotarParams, minDate, maxDate, isChangeAudienceAfterSubmitEnabled, isLearningActivity);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const [taskTypes, setTaskTypes] = (0, _react.useState)([]);
  const [selectedOption, setSelectedOption] = (0, _react.useState)();
  const [taskTypeDescription, setTaskTypeDescription] = (0, _react.useState)('');
  const styles = (0, _TaskType.default)();
  const isNoCheckItem = task?.item?.showMessage;
  const isTaskTypeCanNotChange = task?.cannotModifyMembers && !isTaskTypeChangeEnabled;
  const handleSelectOption = option => {
    setSelectedOption(option);
    if (option.value !== task?.taskType) {
      setIsChanged(true);
      const {
        startDateTime,
        endDateTime,
        publishDate,
        feedbackDate,
        feedbackType
      } = getTaskTiming(option.value.toString(), task.startDateTime, undefined);
      setTask({
        ...task,
        taskType: option.value,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        publishDate: publishDate,
        feedbackDate: feedbackDate,
        feedbackType: feedbackType
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (unitData?.taskTypes) {
      const currentTaskTypes = Object.keys(unitData.taskTypes).filter(key => {
        let addIt = false;
        switch (key) {
          case 'analysis':
            if (task?.item?.isAnalysis && !isNoCheckItem) {
              addIt = true;
            }
            break;
          case 'selfLearning':
            if (isSelfLearningEnabled) {
              addIt = true;
            }
            break;
          case 'evalWork':
            if (!isNoCheckItem) {
              addIt = true;
            }
            break;
          case 'learningWork':
            addIt = true;
            break;
          case 'exam':
            if (task?.cannotModifyMembers && originalTask?.taskType !== 'exam') {
              addIt = false;
            } else {
              if (!isNoCheckItem) {
                addIt = true;
              }
            }
            break;
          default:
            addIt = true;
            break;
        }
        return addIt;
      });
      if (isSelfLearningEnabled) {
        const index = currentTaskTypes.indexOf('selfLearning');
        if (index > -1) {
          currentTaskTypes.splice(index, 1);
        }
        currentTaskTypes.unshift('selfLearning');
      }
      const taskTypesData = currentTaskTypes.map(taskType => {
        return {
          value: taskType,
          label: unitData?.taskTypes[taskType]
        };
      });
      setTaskTypes(taskTypesData);
    }
  }, [isLearningActivity, isNoCheckItem, isSelfLearningEnabled, originalTask?.taskType, task, unitData?.taskTypes]);
  (0, _react.useEffect)(() => {
    if (isChangedBackToExam) {
      setTask({
        ...task,
        taskType: 'exam',
        startDateTime: originalTask?.startDateTime,
        endDateTime: originalTask?.endDateTime,
        publishDate: originalTask?.publishDate,
        feedbackDate: originalTask?.feedbackDate,
        feedbackType: originalTask?.feedbackType
      });
      setIsChangedBackToExam(false);
    }
  }, [isChangedBackToExam, originalTask?.endDateTime, originalTask?.feedbackDate, originalTask?.feedbackType, originalTask?.publishDate, originalTask?.startDateTime, setIsChangedBackToExam, setTask, task]);
  (0, _react.useEffect)(() => {
    if (task?.taskType) setSelectedOption({
      value: task?.taskType,
      label: unitData?.taskTypes[task?.taskType]
    });
  }, [task?.taskType, unitData?.taskTypes]);
  (0, _react.useEffect)(() => {
    const description = selectedOption?.value === 'learningWork' ? getLabel('text_label_taskTypeDescription_learningWork') : selectedOption?.value === 'evalWork' ? getLabel('text_label_taskTypeDescription_evalWork') : selectedOption?.value === 'exam' ? getLabel('text_label_taskTypeDescription_exam') : '';
    setTaskTypeDescription(description);
  }, [getLabel, selectedOption]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__task-type'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionLabel.SectionLabel, {
      text: getLabel('text_label_activityType'),
      isDisabled: task && (task.isReadOnly || isTaskTypeCanNotChange || taskTypes?.length <= 1 || isScheduleOnlyExam)
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-TaskManager__task-type-select-and-description'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        value: selectedOption,
        onChange: handleSelectOption,
        anchorWidth: isMobileView ? 'auto' : 'fit-content',
        btnProps: {
          color: 'basic',
          view: 'outlined',
          customStyle: {
            width: isMobileView ? '100%' : pxToRem(language === 'en' ? 225 : 180)
          },
          shape: isMobileView ? 'roundedRectangle' : 'ellipse',
          isDisabled: task && (task.isReadOnly || isTaskTypeCanNotChange || taskTypes?.length <= 1 || isScheduleOnlyExam)
        },
        options: taskTypes
      }), taskTypeDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionDescription.SectionDescription, {
        text: taskTypeDescription
      })]
    })]
  });
};
exports.TaskType = TaskType;